import * as React from "react";
const SvgBarista = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 35, height: 51, viewBox: "0 0 35 51", fill: "none", ...props }, "...");
export default SvgBarista;
